import * as Sentry from "@sentry/react";

import React from 'react';
import ReactDOM from 'react-dom/client';
import Routes from './router';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { store } from './store';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import 'bootstrap/dist/css/bootstrap.min.css';

const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

if (process.env.NODE_ENV === 'production') {
    Sentry.init({
        dsn: process.env.REACT_APP_SENTRY_DSN,
        environment: process.env.NODE_ENV,
        release: process.env.REACT_APP_VERSION,
        integrations: [Sentry.browserTracingIntegration()],
        tracesSampleRate: 0.2,
        sendDefaultPii: true,
        beforeSend(event, hint) {
            const err = hint?.originalException;
            const status = err?.response?.status ?? err?.statusCode;
            if (status && status < 500) return null;
            return event;
        },
    });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Sentry.ErrorBoundary fallback={<p>Nastala neočakávaná chyba. Prosím, obnovte stránku.</p>}>
        <Provider store={store}>
            <GoogleReCaptchaProvider
                reCaptchaKey={RECAPTCHA_KEY}
            >

                <BrowserRouter>
                    <Routes />
                </BrowserRouter>

            </GoogleReCaptchaProvider>
        </Provider>
    </Sentry.ErrorBoundary>
);
